import { useState } from "react";
import Button from "../ui/Button";
import { addEditHealthCheck } from "../../services/labourLaw";
import { toast } from "react-toastify";
import useLoader from "../../hooks/useLoader";
import { getCurrentFinancialYear } from "../../Helper/functionHelper";

const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB

const HealthCheckForm = ({ user, financialYear, onSuccess }) => {
  const { showLoader, hideLoader,loading } = useLoader();
  const [selectedFY, setSelectedFY] = useState(
    financialYear || getCurrentFinancialYear()
  );
  const [isDone, setIsDone] = useState(
    user?.compliance?.healthCheck ? "1" : "0"
  );
  const [file, setFile] = useState(null);

  const generateFinancialYears = (count = 5) => {
    const currentFY = getCurrentFinancialYear();
    const startYear = parseInt(currentFY.split("-")[0], 10);

    return Array.from({ length: count }, (_, i) => {
      const y = startYear - i;
      return `${y}-${y + 1}`;
    });
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile) return;

    // Validate file type
    if (selectedFile.type !== "application/pdf") {
      toast.error("Only PDF files are allowed.");
      e.target.value = "";
      return;
    }

    // Validate file size
    if (selectedFile.size > MAX_FILE_SIZE) {
      toast.error("File size must be less than or equal to 2 MB.");
      e.target.value = "";
      return;
    }

    setFile(selectedFile);
  };

  const handleSubmit = async () => {
    try {
      showLoader();

      // Safety validation before submit
      if (file && file.size > MAX_FILE_SIZE) {
        toast.error("File size must be less than or equal to 2 MB.");
        return;
      }

      const formData = new FormData();
      formData.append("userId", user.userId);
      formData.append("financialYear", selectedFY);
      formData.append("is_health_checked", isDone);

      if (file) {
        formData.append("document", file);
      }

      const res = await addEditHealthCheck(formData);

      if (res?.status === 200) {
        toast.success("Health record updated successfully.");
        onSuccess?.();
      }
    } catch (err) {
      console.error("Health check save failed", err);
      toast.error("Failed to save health check.");
    } finally {
      hideLoader();
    }
  };

  return (
    <>
      {/* Financial Year */}
      <div className="mb-3">
        <label className="form-label">
          Financial Year <span className="text-danger">*</span>
        </label>
        <select
          className="form-select"
          value={selectedFY}
          onChange={(e) => setSelectedFY(e.target.value)}
        >
          {generateFinancialYears(6).map((fy) => (
            <option key={fy} value={fy}>
              {fy}
            </option>
          ))}
        </select>
      </div>

      {/* Health Checked */}
      <div className="mb-3">
        <label className="form-label">
          Is Health Checked <span className="text-danger">*</span>
        </label>
        <select
          className="form-select"
          value={isDone}
          onChange={(e) => setIsDone(e.target.value)}
        >
          <option value="1">Yes</option>
          <option value="0">No</option>
        </select>
      </div>

      {/* Document */}
      <div className="mb-3">
        <label className="form-label">
          Health Check Document (PDF, max 2 MB)
        </label>
        <input
          type="file"
          className="form-control"
          accept="application/pdf"
          onChange={handleFileChange}
        />
        {file && (
          <small className="text-muted">
            Selected: {file.name} ({(file.size / 1024 / 1024).toFixed(2)} MB)
          </small>
        )}
      </div>

      {/* Save */}
      <div className="d-flex justify-content-end">
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Saving..." : "Save"}
        </Button>
      </div>
    </>
  );
};

export default HealthCheckForm;
